import cache from "./cachedState";
import Vue from "vue";

let state = {
  settings: {
    readingMode: "normal",
    textSize: "normal",
    theme: "light"
  }
};

const cachedStateId = "vuex-settings";
var cachedState = cache.load(cachedStateId);
if (cachedState) {
  state = JSON.parse(cachedState);
}
const saveCache = function(state) {
  cache.save(cachedStateId, JSON.stringify(state));
};

let actions = {};

let getters = {};

let mutations = {
  save(state, settings) {
    Object.keys(settings).forEach(k => {
      state.settings[k] = settings[k];
    });
    // console.log('saving');
    // console.log(settings);
    // console.log(state);
    saveCache(state);
  }
};

export default {
  name: "settings",
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
